<template>
    <div>
        <Modal
            v-model="modal1"
            title="物料选择"
            draggable
            :width="720"
            >
            <Form @submit.native.prevent>
                <FormItem>
                    <Input v-model="Value" placeholder="请输入需要查询的值,按回车搜索,不输入默认查询全部" @on-enter="GetMainTablelist"></Input>
                </FormItem>
            </Form>
            <Card :bordered="false" dis-hover class="ivu-mt i-table-no-border">
              <Table :columns="column" :data="tablelist" size="small" max-height="600" @on-select="SelecttionHandleClick"></Table>
              <Page :total="total" show-sizer show-elevator transfer style="margin:1rem 0 0rem 0;text-align: center;"
            @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>
            </Card>
        </Modal>
    </div>
</template>

<script>
import { GetProductInfo } from '@/api/Customer'
export default {
  name: 'component-ProductInfolist',
  props: {
    modal: Boolean
  },
  computed: {
    // 计算属性的 getter
    modal1: {
      get: function () {
        return this.modal
      },
      set: function (value) {
        this.$emit('ProductInfoSetModal', value)
      }
    }
  },
  data () {
    return {
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      Value: '',
      column: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '物料编码',
          key: 'ProductID',
          minWidth: 200,
          maxWidth: 250,
          align: 'center'
        },
        {
          title: '物料名称',
          key: 'Product_Name',
          minWidth: 150,
          maxWidth: 200,
          ellipsis: true,
          tooltip: true,
          align: 'center'
        },
        {
          title: '属性汇总',
          key: 'Attribute_Summary',
          minWidth: 250,
          maxWidth: 300,
          ellipsis: true,
          tooltip: true,
          align: 'center'
        }
      ],
      tablelist: []
    }
  },
  mounted: function () {
    this.GetMainTablelist()
  },
  methods: {
    GetMainTablelist () {
      GetProductInfo(this.Value, this.CurrentPage, this.pageSize).then(res => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.tablelist = res.Data.Table1
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    SelecttionHandleClick (value, row) {
      this.$emit('SelecttionHandleClick', row)
    },
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetMainTablelist()
      }
    },
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.CurrentPage = 1
        this.pageSize = res
        this.GetMainTablelist()
      }
    }
  }
}
</script>
